import {ActionsRow, Icon, layout} from 'mc/lib';
import React, {Component} from 'react';
import {LinkContainer} from 'react-router-bootstrap';
import {Button, ButtonGroup, ButtonToolbar, CardBlock, Nav, NavItem, NavLink} from 'reactstrap';
import {PREDPISY_A_PLATBY_ROUTE} from '../routes';
import PlatbaListPageTab from './tabs/PlatbaListPageTab';
import ZadostListPageTab from './tabs/ZadostListPageTab';
import ZadostApi from "./../api/ZadostApi";
import {toastr} from "react-redux-toastr";

const PLATBY = "platby";
const ZADOSTI = "zadosti";

class PredpisyAPlatbyPage extends Component {

    state = {
        exportingXlsxPrehled: false
    };

    /**
     * Je tab aktivní?
     *
     * @param currentRoute aktuální cesta - předpis
     * @param tab          typ osvětlení objektu
     * @returns {boolean}
     */
    isActiveTab = (currentRoute, tab = null) => {
        if (tab) {
            return currentRoute === PREDPISY_A_PLATBY_ROUTE + "/" + tab + "/";
        } else {
            return currentRoute === PREDPISY_A_PLATBY_ROUTE + "/";
        }
    };

    /**
     * Renderování obsahu tabu.
     *
     * @param currentRoute aktuální cesta - předpis
     * @returns {*}
     */
    renderTabContent = (currentRoute) => {
        if (this.isActiveTab(currentRoute, PLATBY)) {
            return this.renderPlatbyTab();
        } else if (this.isActiveTab(currentRoute, ZADOSTI)) {
            return this.renderZadostiTab();
        } else {
            return this.renderPlatbyTab();
        }
    };

    renderPlatbyTab = () => {
        return <PlatbaListPageTab/>
    };

    renderZadostiTab = () => {
        return <ZadostListPageTab/>
    };

    /**
     * Renderování hlavičky detailu.
     *
     * @returns {*}
     */
    renderDetailHeader = () => {

        const { exportingXlsxPrehled } = this.state;

        const {match} = this.props;
        const currentRoute = match.path;
        const base = PREDPISY_A_PLATBY_ROUTE;
        const currentRouteWithParams = match.url;

        return <div>
            <CardBlock>
                <ActionsRow actions={<ButtonToolbar>
                    <ButtonGroup className="mr-2">
                        <Button type="button"
                                title={"Export do Excelu"}
                                color="default"
                                className={"xlsx-export"}
                                disabled={exportingXlsxPrehled}
                                onClick={() => {
                                    this.exportXlsx();
                                }}>
                            {exportingXlsxPrehled
                                ?
                                <Icon icon="circle-o-notch" animation={Icon.animation.spin} fixedWidth/>
                                : <Icon icon="file"/>}
                            <br/>Export
                        </Button>
                    </ButtonGroup>
                </ButtonToolbar>
                }>
                </ActionsRow>
            </CardBlock>
            {this.renderTabs(base, currentRoute, currentRouteWithParams)}
        </div>;
    };

    /**
     * Render metoda pro záložky detailu.
     *
     * @param base             základní cesta
     * @param currentRoute           aktuální cesta - předpis
     * @param currentRouteWithParams aktuální cesta - s hodnotama
     * @param type                   typ osvětlení objektu
     * @returns {*}
     */
    renderTabs = (base, currentRoute, currentRouteWithParams) => {
        
        return <Nav tabs className="bg-primary-lighten nav-tabs-detail">
            <NavItem>
                <LinkContainer replace to={base + "/" + ZADOSTI}>
                    <NavLink active={this.isActiveTab(currentRoute, ZADOSTI)}>Žádosti</NavLink>
                </LinkContainer>
            </NavItem>
            <NavItem>
                <LinkContainer replace to={base + "/" + PLATBY}>
                    <NavLink active={this.isActiveTab(currentRoute, PLATBY)}>Platby</NavLink>
                </LinkContainer>
            </NavItem>
        </Nav>;
    };

    render() {
        const {match} = this.props;
        const currentRoute = match.path;

        return (
            <div className="app-wrapper">
                <div className="app-wrapper-content">
                    <layout.PageWrapper>
                        <layout.PageContent fullWidth header={this.renderDetailHeader()}>
                            {this.renderTabContent(currentRoute)}
                        </layout.PageContent>
                    </layout.PageWrapper>
                </div>
            </div>
        );
    }

    /**
     * Spuštění exportu do excelu
     */
    exportXlsx() {
        toastr.warning('Pro export existuje příliš mnoho dat. Export nelze provést.');
        // this.setState({exportingXlsxPrehled: true});
        //
        // ZadostApi.exportPredpisuAPlateb()
        //     .then(response => {
        //         this.setState({exportingXlsxPrehled: false});
        //         window.open(serverContextPath + `/files/temp/${response}`, "_blank");
        //     }).catch(error => {
        //     this.setState({exportingXlsxPrehled: false});
        //     console.error(error);
        // });
    }


}



export default PredpisyAPlatbyPage;
